import { useListBigQueryRoutines } from '../../../../../query/acg/phase-1';
import { Controller, useFormContext } from 'react-hook-form';
import { Select } from 'antd';
import React from 'react';

export default function RoutineSelector() {
  const { data, isLoading } = useListBigQueryRoutines();
  const form = useFormContext();
  return (
    <Controller
      control={form.control}
      name="routineName"
      render={({ field }) => {
        return (
          <div className="w-full space-y-2">
            <b>Routine Name</b>
            <Select
              className="w-full"
              loading={isLoading}
              value={field.value}
              onChange={field.onChange}
            >
              <Select.Option value="">Select a routine</Select.Option>
              {data?.map(routine => (
                <Select.Option
                  key={routine.routineName}
                  value={routine.routineName}
                >
                  {routine.routineName}
                </Select.Option>
              ))}
            </Select>
          </div>
        );
      }}
    />
  );
}
